export default "__VITE_ASSET__RsGIDylA__"